"use client";

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "./utils";

function Progress({
  className,
  indicatorClassName,
  value,
  max = 100,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { indicatorClassName?: string }) {
  const numericValue = typeof value === "number" && Number.isFinite(value) ? value : 0;
  const maxValue = typeof max === "number" && Number.isFinite(max) && max > 0 ? max : 100;
  const safeValue = Math.min(maxValue, Math.max(0, numericValue));
  const percentage = (safeValue / maxValue) * 100;

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={safeValue}
      max={maxValue}
      className={cn(
        "bg-secondary relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-primary h-full w-full flex-1 transition-transform motion-reduce:transition-none",
          indicatorClassName,
        )}
        style={{ transform: `translateX(-${100 - percentage}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
